/* ------------------------------------ */
// Navbar data section
/* ------------------------------------ */
import logo from "../../image/appCreative/logo.png"
import logoWhite from "../../image/appCreative/logo-white.png"
export const navbar = {
    logoImage: logo,
    logoImageWhite: logoWhite,
    navMenu: [
{
            id: 1,
            label: "Platform",
            path: "/platform"
            // offset: "80",
        },
        {
            id: 2,
            label: "About",
            path: "about"
            // offset: "73",
        },
        // {
        //     id: 3,
        //     label: "Team",
        //     path: "#",
        //     offset: "73",
        // },
        {
            id: 4,
            label: "Contact",
            path: "#"
            // offset: "73",
        }
        // {
        //     id: 5,
        //     label: "FAQ",
        //     path: "#faq",
        //     offset: "73",
        // },
    ]
}

/* ------------------------------------ */
// Key Features data section
/* ------------------------------------ */
import keyFeature1 from "../../image/appCreative/key_feature/1.png"
import keyFeature2 from "../../image/appCreative/key_feature/2.png"
import keyFeature3 from "../../image/appCreative/key_feature/3.png"
import keyFeature4 from "../../image/appCreative/key_feature/wheel-icon.png";

export const keyFeatures = {
  title: "Add Games to Your E-Shop",
  slogan:
    "Our games provide a chance to win coupons and benefits that make shoppers feel like they won something special others didn't.",
  features: [
    {
      id: 1,
      icon: keyFeature1,
      title: "Basketball",
      description: "basketball",
    },
    {
      id: 2,
      icon: keyFeature2,
      title: "Puzzle",
      description: "puzzle",
    },
    {
      id: 3,
      icon: keyFeature3,
      title: "Bricks",
      description: "bricks",
    },
    {
      id: 4,
      icon: keyFeature4,
      title: "Wheel of Fortune",
      description: "wheel",
    },
  ],
};

/* ------------------------------------ */
// Choose us data section
/* ------------------------------------ */
import chooseThumb from "../../image/appCreative/chooseThumb.png"
import featureIcon1 from "../../image/appCreative/icon1.png"
import featureIcon2 from "../../image/appCreative/icon2.png"
import featureIcon3 from "../../image/appCreative/icon3.png"
import featureIcon4 from "../../image/appCreative/timer-icon.png";

export const chooseUs = {
  title: "Why should you use our games?",
  thumb: chooseThumb,
  features: [
    {
      id: 1,
      title: "Boost Conversion Rates",
      icon: featureIcon1,
      description:
        "A White Castle campaign where consumers earned a coupon for a free product after playing a game saw a 36% conversion to purchase from that campaign ",
    },
    {
      id: 2,
      title: "Collect More Emails",
      icon: featureIcon2,
      description: "By giving users the coupon to their email after winning",
    },
    {
      id: 3,
      title: "Reduced Price Per Click",
      icon: featureIcon3,
      description:
        "Promote game ads rather than generic ads, make your ads stand out, and get more clicks.",
    },
    {
      id: 4,
      title: "Convert Faster",
      icon: featureIcon4,
      description:
        "Using a countdown timer after winning a coupon forces the user to convert faster knowing the discount's expiration time.",
    },
  ],
};

/* ------------------------------------ */
// Experience data section
/* ------------------------------------ */
import expIcon1 from "../../image/appCreative/platform/video-console.png"
import expIcon2 from "../../image/appCreative/platform/image-editing.png"
import expIcon3 from "../../image/appCreative/platform/dashboard.png"
import expIcon4 from "../../image/appCreative/platform/curve.png"
import videoTheme from "../../image/appCreative/platform/video-thumb.jpg"

// Client Logo
import geekwire from "../../image/appCreative/client_logo/1.png"
import slack from "../../image/appCreative/client_logo/2.png"
import envato from "../../image/appCreative/client_logo/3.png"
import usaToday from "../../image/appCreative/client_logo/4.png"
import forbes from "../../image/appCreative/client_logo/5.png"
import evernote from "../../image/appCreative/client_logo/6.png"

export const experiences = {
    title: "Wiply Game Building Platform",
    slogan: "Build shopping games for your brand using our intuitive DIY tool and increase conversion rates!.",
    video_theme: videoTheme,
    features: [
{
            id: 1,
            icon: expIcon1,
            title: "Game Library",
            description: "Users of our platform can choose from a variety of games and coupons and easily customize them."
          },
        {
            id: 2,
            icon: expIcon2,
            title: "Graphics Bank",
            description: "No graphic designer needed! Choose your background from our library or create your own using our simple interface."
        },
        {
            id: 3,
            icon: expIcon3,
            title: "Insights Dashboard",
            description: "Get access to your very own dashboard and follow the game performance in real time."
        },
        {
            id: 4,
            icon: expIcon4,
            title: "Design Support",
            description: "Subscribe to our elite program and receive design support to make your game even more unique with custom designs!"
        }
    ],
    clients: [
{
            id: 1,
            logo: geekwire,
            name: "geekwire",
            link: "#1"
        },
        {
            id: 2,
            logo: slack,
            name: "slack",
            link: "#2"
        },
        {
            id: 3,
            logo: envato,
            name: "envato",
            link: "#3"
        },
        {
            id: 4,
            logo: usaToday,
            name: "usa today",
            link: "#4"
        },
        {
            id: 5,
            logo: forbes,
            name: "forbes",
            link: "#5"
        },
        {
            id: 6,
            logo: evernote,
            name: "evernote",
            link: "#6"
        }
    ]
}

/* ------------------------------------ */
// Features data section
/* ------------------------------------ */
import Image1 from "../../image/appCreative/feature/slide1.png"
import Image2 from "../../image/appCreative/feature/slide2.png"
import Image3 from "../../image/appCreative/feature/slide3.png"
import Image4 from "../../image/appCreative/feature/slide4.png"
// import Image5 from "../../image/appCreative/feature/slide1.png";
// import Image6 from "../../image/appCreative/feature/slide2.png";

export const features = {
    title: "How does it work?",
    slogan: "Introduce your shoppers to an innovative and playful e-commerce sales funnel",
    items: [
{
            id: 1,
            thumbnail: Image1,
            title: "Promotion",
            description: "Promote the game on your website and marketing channels."
        },
        {
            id: 2,
            thumbnail: Image2,
            title: "Game",
            description: "Let your customers play a game, not just click and ad."
        },
        {
            id: 3,
            thumbnail: Image3,
            title: "Benefit",
            description: "Every customer receives a personal coupon that is hard to resist!"
        },
        {
            id: 4,
            thumbnail: Image4,
            title: "Redemption",
            description: "Coupons have to be redeemed in real time increasing conversion rates."
        }
        // {
        //     id: 5,
        //     thumbnail: Image5,
        //     title: "Professional Environment",
        //     description: "We enjoy office retreats and visit famous places of our country and abroad also.",
        // },
        // {
        //     id: 6,
        //     thumbnail: Image6,
        //     title: "Professional Environment",
        //     description: "We enjoy office retreats and visit famous places of our country and abroad also.",
        // },
    ]
}

/* ------------------------------------ */
// Pricing data section
/* ------------------------------------ */
export const pricing = {
    title: "Meet our exciting Pricing Plan",
    slogan: "We designed our pricing plan with affordable price for users",
    pricingFeature: [
{
            id: 1,
            name: "Full Access Library"
        },
        {
            id: 2,
            name: "Multiple user"
        },
        {
            id: 3,
            name: "Refund Policy"
        },
        {
            id: 4,
            name: "Google Analytics"
        },
        {
            id: 5,
            name: "24/7 support"
        }
    ],
    pricingItems: [
{
            id: 1,
            package_name: "Starter Pack",
            price: "18",
            trial_day: 15,
            isRecommended: false,
            features: [
{
                    id: 1,
                    name: "Full Access Library",
                    isAvailable: true
                },
                {
                    id: 2,
                    name: "Multiple user",
                    isAvailable: true
                },
                {
                    id: 3,
                    name: "Refund Policy",
                    isAvailable: false
                },
                {
                    id: 4,
                    name: "Google Analytics",
                    isAvailable: false
                },
                {
                    id: 5,
                    name: "24/7 support",
                    isAvailable: false
                }
            ]
        },
        {
            id: 2,
            package_name: "Premium Pack",
            price: "29",
            trial_day: 30,
            isRecommended: true,
            features: [
{
                    id: 1,
                    name: "Full Access Library",
                    isAvailable: true
                },
                {
                    id: 2,
                    name: "Multiple user",
                    isAvailable: true
                },
                {
                    id: 3,
                    name: "Refund Policy",
                    isAvailable: true
                },
                {
                    id: 4,
                    name: "Google Analytics",
                    isAvailable: false
                },
                {
                    id: 5,
                    name: "24/7 support",
                    isAvailable: false
                }
            ]
        },
        {
            id: 3,
            package_name: "Ultimate Pack",
            price: "35",
            trial_day: 45,
            isRecommended: false,
            features: [
{
                    id: 1,
                    name: "Full Access Library",
                    isAvailable: true
                },
                {
                    id: 2,
                    name: "Multiple user",
                    isAvailable: true
                },
                {
                    id: 3,
                    name: "Refund Policy",
                    isAvailable: true
                },
                {
                    id: 4,
                    name: "Google Analytics",
                    isAvailable: true
                },
                {
                    id: 5,
                    name: "24/7 support",
                    isAvailable: false
                }
            ]
        }
    ]
}

/* ------------------------------------ */
// Testimonial data section
/* ------------------------------------ */
import reviewer1 from "../../image/appCreative/client/client-avatar-1.jpg"
import reviewer2 from "../../image/appCreative/client/client-avatar-2.jpg"
import reviewer3 from "../../image/appCreative/client/client-avatar-3.jpg"

export const testimonial = {
    title: "What our clients say about us",
    slogan: "Some inspirational feedback from our customers on twitter",
    reviews: [
{
            id: 1,
            description: "OMG! I cannot believe that I have got a brand new landing page after getting this template we are able to use our most used e-commerce for your branding site to make a profitable and make it cool with fast loading experience.",
            avatar: reviewer1,
            name: "Jonathan Taylor",
            designation: "CEO at Creativex",
            twitterProfile: "https://twitter.com/redqinc"
        },
        {
            id: 2,
            description: "@redqteam is great for creating with landing pages within minutes! It then actually takes less time…",
            avatar: reviewer2,
            name: "Gavin Park",
            designation: "CEO at Orbital",
            twitterProfile: "https://twitter.com/redqinc"
        },
        {
            id: 3,
            description: "Whenever I need to create a new cool ecommerce site for clients @redqteam is my solution is the best agency. We are super excited about it.",
            avatar: reviewer3,
            name: "Betty Norton",
            designation: "Freelance Designer",
            twitterProfile: "https://twitter.com/redqinc"
        },

        {
            id: 4,
            description: "Whenever I need to create a new cool ecommerce site for clients @redqteam is my solution is the best agency. We are super excited about it. profitable and make it cool with fast loading experience & it make the site more customizable & fluent.",
            avatar: reviewer3,
            name: "Betty Norton",
            designation: "Freelance Designer",
            twitterProfile: "https://twitter.com/redqinc"
        },
        {
            id: 5,
            description: "We are really excited that we have got a brand new landing page after getting this template we are able to use our most used e-commerce for your branding site to make a profitable and make it cool with fast loading experience.",
            avatar: reviewer1,
            name: "Jonathan Taylor",
            designation: "CEO at Creativex",
            twitterProfile: "https://twitter.com/redqinc"
        },
        {
            id: 6,
            description: "Whenever I need to create a new cool ecommerce site for clients, @redqteam is my solution is the best agency. ",
            avatar: reviewer3,
            name: "Betty Norton",
            designation: "Freelance Designer",
            twitterProfile: "https://twitter.com/redqinc"
        }
    ]
}

/* ------------------------------------ */
// Available Store data section
/* ------------------------------------ */
import availableThumb from "../../image/appCreative/availableThumb.png"

export const availableStore = {
    title: "Add gamification to your e-commerce funnel.",
    description: "Spend your marketing budget on the right things.",
    thumb: availableThumb,
    numberPrefix: [
{
            label: "+13",
            value: "13"
        },
        {
            label: "+14",
            value: "14"
        },
        {
            label: "+15",
            value: "15"
        },
        {
            label: "+16",
            value: "16"
        },
        {
            label: "+17",
            value: "17"
        },
        {
            label: "+18",
            value: "18"
        }
    ]
}


import ctaAboutThumb from "../../image/appCreative/about/engagement.png"

export const ctaAbout = {
    title: "that move  the needle",
    description: "Create engagements ",
    thumb: ctaAboutThumb,
    numberPrefix: [
{
            label: "+13",
            value: "13"
        },
        {
            label: "+14",
            value: "14"
        },
        {
            label: "+15",
            value: "15"
        },
        {
            label: "+16",
            value: "16"
        },
        {
            label: "+17",
            value: "17"
        },
        {
            label: "+18",
            value: "18"
        }
    ]
}
/* ------------------------------------ */
// Faq data section
/* ------------------------------------ */
export const faq = {
    title: "Frequently Ask Question",
    slogan: "What are you looking for and find the solution on our FAQ page",
    faqs: [
{
            id: 1,
            question: "Which domain should I purchase?",
            answer: "We make it easy to move to CometNine. Simply contact us and we'll move your hosting account from any other provider, regardless of the control panel. If at anytime your website is down for more than 0.1% result"
        },
        {
            id: 2,
            question: "Can I upgrade or downgrade my web hosting plan",
            answer: "The pricing made me a little hesitant at first but I have been pleasantly surprised by the level of care given by CometNine."
        },
        {
            id: 3,
            question: "How do I upgrade the storage capacity of my hosting plan?",
            answer: "Stop your viewers from getting distracted. Publish videos to your own Channel and rest easy knowing viewers won’t be annoyed by ads or pulled down a rabbit hole of unrelated videos."
        },
        {
            id: 4,
            question: "What are some tips when choosing a name?",
            answer: "Get your website tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news."
        },
        {
            id: 5,
            question: "What is in Motion Hosting’s uptime rate?",
            answer: "Designed with beginners in mind and packed with advanced features developers will love. Start with a quick and simple install"
        },
        {
            id: 6,
            question: "What if I need help choosing the right domain?",
            answer: "Create a hub for cross-functional work that also works with all your other tools. Centralize and standardize communication with Miro. All premium functional are included here with updates."
        },
        {
            id: 7,
            question: "Learn from community on Brandwagon",
            answer: "Brian Halligan knows that you need more than a great product to have a great brand. Hear his thoughts & score a peek at our wagon."
        }
    ]
}

/* ------------------------------------ */
// Footer data section
/* ------------------------------------ */
import { Icon } from "react-icons-kit"
import { facebook } from "react-icons-kit/fa/facebook"
import { instagram } from "react-icons-kit/fa/instagram"
import { linkedin } from "react-icons-kit/fa/linkedin"
import footerLogo from "../../image/appCreative/logo.png"

export const footerWidget = {
    logo: footerLogo,
    siteName: "Wiply",
    siteUrl: "#",
    socialLinks: [
{
            id: 1,
            icon: < Icon icon = { facebook }
            />,
            name: "facebook",
            link: "https://www.facebook.com/WiplyGames"
        },
        {
            id: 2,
            icon: < Icon icon = { linkedin }
            />,
            name: "linkedin",
            link: "http://linkedin.com/company/wiplygames"
        },
        {
            id: 3,
            icon: < Icon icon = { instagram }
            />,
            name: "instagram",
            link: "https://www.instagram.com/wiplygames"
        }
    ],
    aboutUs: {
        title: "About Us",
        menuItems: [
            //   {
            //     id: 1,
            //     url: "#",
            //     text: "Support Center",
            //   },
            {
                id: 2,
                url: "/articles",
                text: "Blog"
            },
            {
                id: 3,
                url: "/about",
                text: "About"
            },
            {
                id: 4,
                url: "/terms-conditions",
                text: "Terms & Conditions"
            }
        ]
    },
    ourInformation: {
        title: "Our Information",
        menuItems: [
{
                id: 1,
                url: "/refund-policy",
                text: "Return Policy"
            },
            {
                id: 2,
                url: "/privacy-policy",
                text: "Privacy Policy"
            },
            {
                id: 3,
                url: "/delivery-policy",
                text: "Delivery Policy"
            }
        ]
    },
    myAccount: {
        title: "My Account",
        menuItems: [
            //   {
            //     id: 1,
            //     url: "#",
            //     text: "Press inquiries",
            //   },
            //   {
            //     id: 2,
            //     url: "#",
            //     text: "Social media",
            //   },
            //   {
            //     id: 3,
            //     url: "#",
            //     text: "Directories",
            //   },
            //   {
            //     id: 4,
            //     url: "#",
            //     text: "Permissions",
            //   },
        ]
    }
}

/* ------------------------------------ */
// Pricing data section
/* ------------------------------------ */
export const MONTHLY_PRICING_TABLE = [
{
        isRecomended: true,
        name: "Starter",
        price: "FREE",
        priceLabel: "",
        buttonLabel: "Start",
        url: "/register",
        listItems: [
{
                isDisabled: false,
                content: "Limited Games (Puzzle, Quiz, Memory, Wheel)"
            },
            {
                isDisabled: false,
                content: "Up to 100 Free Players / Month"
            },
            {
                isDisabled: false,
                content: "Limited Leads"
            },
            {
                isDisabled: false,
                content: "Limited Analytics"
            },
            {
                isDisabled: false,
                content: "Integrations"
            },
            
            {
                isDisabled: false,
                content: "Storage 2GB"
            },
    
            {
                isDisabled: true,
                content: "CNAME / Custom Domain"
            },
            {
                isDisabled: true,
                content: "White Label"
            }
        ]
    },
    {
        isRecomended: false,
        name: "Pro",
        price: "$49",
        priceLabel: "/mo",
        buttonLabel: "Start",
        url: "/register",
        listItems: [
            {
                            isDisabled: false,
                            content: "Limited Games (Starter Plan Games, Tower, Basketball, Brick)"
                        },
                        {
                            isDisabled: false,
                            content: "Up to 1800 Players / Month (Beyond free quota, $0.01 / Player)"
                        },
                        {
                            isDisabled: false,
                            content: "Limited Leads"
                        },
                        {
                            isDisabled: false,
                            content: "Limited Analytics"
                        },
                        {
                            isDisabled: false,
                            content: "Integrations"
                        },
                        
                        {
                            isDisabled: false,
                            content: "Storage 10GB"
                        },
                
                        {
                            isDisabled: true,
                            content: "CNAME / Custom Domain"
                        },
                        {
                            isDisabled: true,
                            content: "White Label"
                        }
                    ]
    },
    {
        isRecomended: true,
        name: "Pro Plus",
        price: "$109",
        
        priceLabel: "/mo",
        buttonLabel: "Start",
        url: "#",
        listItems: [
            {
                            isDisabled: false,
                            content: "All Games"
                        },
                        {
                            isDisabled: false,
                            content: "Up to 4800 Players / Month (Beyond free quota, $0.0075 / Player)"
                        },
                        {
                            isDisabled: false,
                            content: "Full Leads"
                        },
                        {
                            isDisabled: false,
                            content: "Full Analytics"
                        },
                        {
                            isDisabled: false,
                            content: "Integrations"
                        },
                        
                        {
                            isDisabled: false,
                            content: "Storage 15GB"
                        },
                
                        {
                            isDisabled: false,
                            content: "20 CNAME / Custom Domain"
                        },
                        {
                            isDisabled: true,
                            content: "White Label"
                        }
                    ]
    },
    {
        isRecomended: true,
        name: "Premium",
        price: "$249",
        
        priceLabel: "/mo",
        buttonLabel: "Start",
        url: "#",
        listItems: [
            {
                            isDisabled: false,
                            content: "All Games"
                        },
                        {
                            isDisabled: false,
                            content: "Up to 15000 Players / Month (Beyond free quota, $0.005 / Player)"
                        },
                        {
                            isDisabled: false,
                            content: "Full Leads"
                        },
                        {
                            isDisabled: false,
                            content: "Full Analytics"
                        },
                        {
                            isDisabled: false,
                            content: "Integrations"
                        },
                        
                        {
                            isDisabled: false,
                            content: "Storage 20GB"
                        },
                
                        {
                            isDisabled: false,
                            content: "50 CNAME / Custom Domain"
                        },
                        {
                            isDisabled: true,
                            content: "White Label"
                        }
                    ]
    },
    {
        isRecomended: true,
        name: "Enterprise",
        price: "CONTACT US",
        
        priceLabel: "",
        buttonLabel: "Contact Us",
        url: "#",
        listItems: [
            {
                            isDisabled: false,
                            content: "All Games"
                        },
                        {
                            isDisabled: false,
                            content: "Custom Players / Month"
                        },
                        {
                            isDisabled: false,
                            content: "Full Leads"
                        },
                        {
                            isDisabled: false,
                            content: "Full Analytics"
                        },
                        {
                            isDisabled: false,
                            content: "Integrations"
                        },
                        
                        {
                            isDisabled: false,
                            content: "Custom Storage"
                        },
                
                        {
                            isDisabled: false,
                            content: "Unlimited CNAME / Custom Domain"
                        },
                        {
                            isDisabled: false,
                            content: "White Label"
                        }
                    ]
    }
]

export const YEARLY_PRICING_TABLE = [
{
        isRecomended: true,
        name: "Pro",
        price: "$149",
        priceLabel: "/mo",
        buttonLabel: "Start",
        url: "/register",
        listItems: [
{
                isDisabled: false,
                content: "Up to 10,00 users"
            },
            {
                isDisabled: false,
                content: "Full Game Library"
            },
            {
                isDisabled: false,
                content: "Graphic Bank"
            },
            {
                isDisabled: false,
                content: "Insight Dashboard"
            },
            {
                isDisabled: true,
                content: "Design Support"
            },
            {
                isDisabled: true,
                content: "Custom Game"
            }
        ]
    },
    {
        isRecomended: false,
        name: "Elite",
        price: "$349",
        priceLabel: "/mo",
        buttonLabel: "Start",
        url: "/register",
        listItems: [
{
                isDisabled: false,
                content: "Unlimited"
            },
            {
                isDisabled: false,
                content: "Full Game Library"
            },
            {
                isDisabled: false,
                content: "Graphic Bank"
            },
            {
                isDisabled: false,
                content: "Insight Dashboard"
            },
            {
                isDisabled: false,
                content: "Design Support"
            },
            {
                isDisabled: true,
                content: "Custom Game"
            }
        ]
    },
    {
        isRecomended: false,
        name: "Enterprise",
        price: "Get a game of your own!",
        priceLabel: "",
        buttonLabel: "Contact Us",
        url: "#",
        listItems: [
{
                isDisabled: false,
                content: "Unlimited"
            },
            {
                isDisabled: false,
                content: "Full Game Library"
            },
            {
                isDisabled: false,
                content: "Graphic Bank"
            },
            {
                isDisabled: false,
                content: "Insight Dashboard"
            },
            {
                isDisabled: false,
                content: "Design Support"
            },
            {
                isDisabled: false,
                isDisabled: false,
                isDisabled: false,
                content: "Custom Game"
            }
        ]
    }
]

export const MONTHLY_PRICING_DATA = [
  {
    recommended: false,
    title: "Lite",
    price: "Free",
    tagline: "with restrictions",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Manage conversations directly from your websites optimization.",
      },
      {
        text: "Unlimited links",
      },
      {
        text: "Chat promt supported",
      },
      {
        text: "Optimzed hashtags",
      },
      {
        text: "Own analytics platform",
      },
    ],
    button: {
      label: "Start 21 days of free trial",
      link: "#",
    },
  },
  {
    recommended: true,
    title: "Pro",
    price: "$15.93",
    tagline: "Monthly",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Manage conversations directly from your websites optimization.",
      },
      {
        text: "Unlimited links",
      },
      {
        text: "Chat promt supported",
      },
      {
        text: "Optimzed hashtags",
      },
      {
        text: "Own analytics platform",
      },
    ],
    button: {
      label: "Start 21 days of free trial",
      link: "#",
    },
  },
  {
    recommended: false,
    title: "Enterprise",
    price: "Get a game of your own!",
    tagline: "",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Unlimited",
      },
      {
        text: "Full Game Library",
      },
      {
        text: "Graphic Bank",
      },
      {
        text: "Insight Dashboard",
      },
      {
        text: "Design Support",
      },
      {
        text: "Custom Game",
      },
    ],
    button: {
      label: "Start 21 days of free trial",
      link: "#",
    },
  },
];

export const YEARLY_PRICING_DATA = [
  {
    recommended: false,
    title: "Lite",
    price: "Free",
    tagline: "with restrictions",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Manage conversations directly from your websites optimization.",
      },
      {
        text: "Unlimited links",
      },
      {
        text: "Chat promt supported",
      },
      {
        text: "Optimzed hashtags",
      },
      {
        text: "Own analytics platform",
      },
    ],
    button: {
      label: "Start 21 days of free trial",
      link: "#",
    },
  },
  {
    recommended: true,
    title: "Pro",
    price: "$99.93",
    tagline: "Yearly",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Unlimited",
      },
      {
        text: "Full Game Library",
      },
      {
        text: "Graphic Bank",
      },
      {
        text: "Insight Dashboard",
      },
      {
        text: "Design Support",
      },
      {
        text: "Custom Game",
      },
    ],
    button: {
      label: "Contact Us",
      link: "#",
    },
  },
  {
    recommended: false,
    title: "Enterprise",
    price: "Get a game of your own!",
    tagline: "",
    planLabel: "Plan includes:",
    options: [
      {
        text: "Unlimited",
      },
      {
        text: "Full Game Library",
      },
      {
        text: "Graphic Bank",
      },
      {
        text: "Insight Dashboard",
      },
      {
        text: "Design Support",
      },
      {
        text: "Custom Game",
      },
    ],
    button: {
      label: "Start 21 days of free trial",
      link: "#",
    },
  },
];